import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=1ac2a398&functional=true&"
var script = {}
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=1ac2a398&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports